function waitSeconds(seconds: number) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}

export async function ensurePixelIsLoaded(
  pixelName: 'fbq' | 'ttq' | 'twq',
  waitLoops = 0
) {
  if (waitLoops >= 20) throw Error('Pixel failed to initialise');

  if (!window?.[pixelName]) {
    await waitSeconds(0.05);

    return ensurePixelIsLoaded(pixelName, waitLoops + 1);
  }
}
